import { render } from "./SliderArrows.vue?vue&type=template&id=631ad4dc&scoped=true"
import script from "./SliderArrows.vue?vue&type=script&lang=js"
export * from "./SliderArrows.vue?vue&type=script&lang=js"

import "./SliderArrows.vue?vue&type=style&index=0&id=631ad4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ad4dc"]])

export default __exports__